import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import MobilePopup from '../../../component/newPopup/mobilePopup/MobilePopup';
import {TShow} from '../../../component/prompotionPopup/PromotionPopup';
import {resetGlobalState} from '../../../redux/setGlobalState';
import {TState} from '../../../redux/store.type';
import * as css from './OrderChangePhonePopup.css';
import PhoneWizard from './components/PhoneWizard/PhoneWizard';
import {resetCodeInput} from '../../../component/SMSCode/SMSCode';

function OrderChangePhonePopup({show}: {show: TShow}) {
    const {t} = useTranslation('layout');
    const orderData = useSelector((s: TState) => s.crm.orderChangePhone);

    const resetWizard = useCallback(() => {
        resetGlobalState('crm.orderChangePhoneSendXHR');
        resetGlobalState('crm.orderChangePhoneVerifyXHR');
        resetGlobalState('crm.orderChangePhoneDirectXHR');
        resetCodeInput();
    }, []);

    if(!orderData?.oid) return null;

    const closeAll = () => {
        resetGlobalState('crm.orderChangePhone');
        resetGlobalState('ui.show.isOpenOrderChangePhone');
        show.close();
        resetWizard();
    };

    return (
        <css.wrapper data-cy="orderChangePhonePopup">
            <MobilePopup
                showClass={show.showClass}
                close={closeAll}
                dataCyName="OrderChangePhone"
                title={t('orderChangePhoneTitle')}
                list={undefined}
                forwardRef={undefined}
                TopComponent={null}
            >
                <PhoneWizard
                    orderData={orderData}
                    onClose={closeAll}
                />
            </MobilePopup>
        </css.wrapper>
    );
}

export default OrderChangePhonePopup;
